// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","355":"450aba08","455":"748180c4","977":"459ae33c"}[chunkId] + ".chunk.js";
};